import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/lp/fondo.png'


const _withScopeId = n => (_pushScopeId("data-v-2e1b3429"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<nav class=\"navbar navbar-expand-lg navbar-dark sticky-top bg-lav\" data-v-2e1b3429><div class=\"container\" data-v-2e1b3429><a class=\"navbar-brand\" href=\"#\" data-v-2e1b3429>Lavandería Premium</a><button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarNav\" aria-controls=\"navbarNav\" aria-expanded=\"false\" aria-label=\"Toggle navigation\" data-v-2e1b3429><span class=\"navbar-toggler-icon\" data-v-2e1b3429></span></button><div class=\"collapse navbar-collapse\" id=\"navbarNav\" data-v-2e1b3429><ul class=\"navbar-nav ms-auto\" data-v-2e1b3429><li class=\"nav-item\" data-v-2e1b3429><a class=\"nav-link\" href=\"#\" data-v-2e1b3429>Inicio</a></li><li class=\"nav-item\" data-v-2e1b3429><a class=\"nav-link\" href=\"#servi\" data-v-2e1b3429>Servicios</a></li><li class=\"nav-item\" data-v-2e1b3429><a class=\"nav-link\" href=\"#about\" data-v-2e1b3429>Sobre Nosotros</a></li></ul></div></div></nav><div class=\"hero\" data-v-2e1b3429></div><div class=\"container my-5\" id=\"about\" data-v-2e1b3429><div class=\"row\" data-v-2e1b3429><div class=\"col-md-6\" data-v-2e1b3429><img src=\"" + _imports_0 + "\" alt=\"Calidad Premium\" class=\"img-fluid\" data-v-2e1b3429></div><div class=\"col-md-6 d-flex flex-column justify-content-center\" data-v-2e1b3429><h2 data-v-2e1b3429>Calidad Premium, para clientes Premium.</h2><p data-v-2e1b3429>Una lavandería sustentable que viene a revolucionar el modo de lavado en Chetumal, desde lo más sencillo hasta lo más importante.</p><a href=\"https://api.whatsapp.com/send?phone=5219831392289&amp;text=Buen%20d%C3%ADa%2C%20me%20interesa%20el%20servicio%20de%20recolecci%C3%B3n%20y%20lavado%20para%20negocio.\" target=\"_blank\" class=\"btn btn-primary\" data-v-2e1b3429> ¡Vamos a chatear! </a></div></div></div><div class=\"testimonials text-center\" data-v-2e1b3429><div class=\"container\" data-v-2e1b3429><div class=\"row\" data-v-2e1b3429><div class=\"col-md-4\" data-v-2e1b3429><blockquote class=\"blockquote\" data-v-2e1b3429><p data-v-2e1b3429>&quot;Best laundry service in Chetumal! La mejor lavandería de Chetumal!&quot;</p><footer class=\"blockquote-footer\" data-v-2e1b3429>Alejandro P.</footer></blockquote></div><div class=\"col-md-4\" data-v-2e1b3429><blockquote class=\"blockquote\" data-v-2e1b3429><p data-v-2e1b3429>&quot;Hasta ahorita es la mejor lavandería que he encontrado en Chetumal y el plus es que aceptan tarjetas!&quot;</p><footer class=\"blockquote-footer\" data-v-2e1b3429>Victor D.</footer></blockquote></div><div class=\"col-md-4\" data-v-2e1b3429><blockquote class=\"blockquote\" data-v-2e1b3429><p data-v-2e1b3429>&quot;Súper rápido en 1 día todo estaba limpio y personal muy agradable!&quot;</p><footer class=\"blockquote-footer\" data-v-2e1b3429>Javier V.</footer></blockquote></div></div></div></div>", 4)
const _hoisted_5 = {
  class: "container my-5",
  id: "servi"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Nuestros Servicios", -1))
const _hoisted_7 = { class: "row text-center services div-con-scroll" }
const _hoisted_8 = {
  class: "card shadow-lg",
  style: {"width":"22rem"}
}
const _hoisted_9 = { class: "div-img-top" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://api.whatsapp.com/send?phone=5219831392289&text=Buen%20d%C3%ADa%2C%20me%20interesa%20el%20servicio%20de%20recolecci%C3%B3n%20y%20lavado%20para%20negocio.",
      target: "_blank",
      class: "btn"
    }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "btn btn-primary btn-lg",
        style: {"background":"linear-gradient(90deg, #20c997, #0d6efd)","border":"none"}
      }, " Solicitar el Servicio ")
    ])
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container my-5" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Sucursales"),
  /*#__PURE__*/_createElementVNode("div", { class: "row text-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("h5", null, "Suc. Erick Paolo"),
      /*#__PURE__*/_createElementVNode("p", null, "Av. Erick Paolo entre Av. Magisterio y Miguel Alemán"),
      /*#__PURE__*/_createElementVNode("p", null, "Tel: 983 133 81 11"),
      /*#__PURE__*/_createElementVNode("iframe", {
        src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.0870457985434!2d-88.31167992420299!3d18.524968169038765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f5ba4a363940a1b%3A0xf33826ef64921713!2sLavanderia%20Premium!5e0!3m2!1ses-419!2smx!4v1720576627889!5m2!1ses-419!2smx",
        width: "600",
        height: "450",
        style: {"border":"0"},
        allowfullscreen: "false",
        loading: "lazy",
        class: "branch-map",
        referrerpolicy: "no-referrer-when-downgrade"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("h5", null, "Suc. Américas I"),
      /*#__PURE__*/_createElementVNode("p", null, "Av. Luis Manuel Sevilla entre Guyana y Paraguay"),
      /*#__PURE__*/_createElementVNode("p", null, "Tel: 983 139 22 89"),
      /*#__PURE__*/_createElementVNode("iframe", {
        src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30260.753199012815!2d-88.30733235303559!3d18.547233611297514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f5ba5e7b8a4f265%3A0xa537cc7a01434944!2sLavanderia%20Premium%20Sucursal!5e0!3m2!1ses-419!2smx!4v1726331091787!5m2!1ses-419!2smx",
        width: "600",
        height: "450",
        style: {"border":"0"},
        allowfullscreen: "false",
        loading: "lazy",
        class: "branch-map",
        referrerpolicy: "no-referrer-when-downgrade"
      })
    ])
  ])
], -1))
const _hoisted_13 = { class: "container my-5 text-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Algunos de nuestros Clientes", -1))
const _hoisted_15 = { class: "row" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://api.whatsapp.com/send?phone=5219831392289&text=Buen%20d%C3%ADa%2C%20me%20interesa%20el%20servicio%20de%20recolecci%C3%B3n%20y%20lavado%20para%20negocio.",
    target: "_blank",
    class: "btn btn-primary"
  }, "Solicita una Cotización")
], -1))

import { Iservicios } from '@/app/model/servicios';
import { ref, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'lavanderiaView',
  setup(__props) {

const services: Ref<Iservicios[]> = ref([
    {
        img: require('@/assets/img/lp/servicios/servicio (1).png'),
        alt: 'servicio1'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (2).png'),
        alt: 'servicio2'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (3).png'),
        alt: 'servicio3'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (4).png'),
        alt: 'servicio4'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (5).png'),
        alt: 'servicio5'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (6).png'),
        alt: 'servicio6'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (10).png'),
        alt: 'servicio10'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (11).png'),
        alt: 'servicio11'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (12).png'),
        alt: 'servicio12'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (13).png'),
        alt: 'servicio13'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (14).png'),
        alt: 'servicio14'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (15).png'),
        alt: 'servicio15'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (16).png'),
        alt: 'servicio16'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (17).png'),
        alt: 'servicio17'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (18).png'),
        alt: 'servicio18'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (19).png'),
        alt: 'servicio19'
    },
    {
        img: require('@/assets/img/lp/servicios/servicio (20).png'),
        alt: 'servicio20'
    }
]);

const clients: Ref<Iservicios[]> = ref([
    {
        img: require('../assets/img/lp/clientes/clientes (1).png'),
        alt: 'cliente 1'
    },
    {
        img: require('../assets/img/lp/clientes/clientes (2).png'),
        alt: 'cliente 2'
    },
    {
        img: require('../assets/img/lp/clientes/clientes (3).png'),
        alt: 'cliente 3'
    },
    {
        img: require('../assets/img/lp/clientes/clientes (4).png'),
        alt: 'cliente 4'
    },
    {
        img: require('../assets/img/lp/clientes/clientes (5).png'),
        alt: 'cliente 5'
    },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, (service) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex justify-content-center align-items-center mt-3 col-md-3",
            key: service.alt
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: service.img,
                  class: "img-fluid",
                  alt: service.alt
                }, null, 8, _hoisted_10)
              ]),
              _hoisted_11
            ])
          ]))
        }), 128))
      ])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients.value, (client) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-2",
            key: client.alt
          }, [
            _createElementVNode("img", {
              src: client.img,
              alt: client.alt
            }, null, 8, _hoisted_16)
          ]))
        }), 128))
      ]),
      _hoisted_17
    ])
  ], 64))
}
}

})